import { render, staticRenderFns } from "./SaidasLista.vue?vue&type=template&id=92ecb5b4&scoped=true"
import script from "./SaidasLista.vue?vue&type=script&lang=js"
export * from "./SaidasLista.vue?vue&type=script&lang=js"
import style0 from "./SaidasLista.vue?vue&type=style&index=0&id=92ecb5b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ecb5b4",
  null
  
)

export default component.exports